import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Checkbox } from 'react-bootstrap';

import { updateProfessionalInfo } from '../actions';

class OtherWorkExperience extends Component {
  constructor(props){
    super(props);
    this.handleOtherLicenseNameChange = this.handleOtherLicenseNameChange.bind(this);
    this.handleOtherLicenseToggle = this.handleOtherLicenseToggle.bind(this);
    this.handleOtherWorkHoursToggle = this.handleOtherWorkHoursToggle.bind(this);
    this.handleVolunteerHoursToggle = this.handleVolunteerHoursToggle.bind(this);
  }

  handleOtherLicenseNameChange(e){
    const updates = {
      otherLicenseOrCert: {
        ...this.props.professionalInfo.otherLicenseOrCert,
        name: e.target.value
      }
    };
    this.props.dispatch(updateProfessionalInfo(updates));
  }

  handleOtherLicenseToggle(){
    const updates = {
      otherLicenseOrCert: {
        ...this.props.professionalInfo.otherLicenseOrCert,
        hasOtherLicenseOrCert: !this.props.professionalInfo.otherLicenseOrCert.hasOtherLicenseOrCert
      }
    };

    // DynamoDB hates empty strings so we delete the attribute when not used
    if(updates.otherLicenseOrCert.hasOtherLicenseOrCert)
      updates.otherLicenseOrCert.name = '';
    else
      delete updates.otherLicenseOrCert.name;

    this.props.dispatch(updateProfessionalInfo(updates));
  }

  handleOtherWorkHoursToggle(){
    const updates = {
      hasOtherWorkHours: !this.props.professionalInfo.hasOtherWorkHours
    };
    this.props.dispatch(updateProfessionalInfo(updates));
  }

  handleVolunteerHoursToggle(){
    const updates = {
      hasVolunteerHours: !this.props.professionalInfo.hasVolunteerHours
    };
    this.props.dispatch(updateProfessionalInfo(updates));
  }

  render() {
    const { professionalInfo } = this.props;
    const otherLicense = professionalInfo.otherLicenseOrCert.hasOtherLicenseOrCert;
    const otherWorkHours = professionalInfo.hasOtherWorkHours;
    const volunteerHours = professionalInfo.hasVolunteerHours;
    return (
      <div>
        <FormGroup>
          <Col md={12}>
            <ControlLabel>Other Work Experience</ControlLabel>
          </Col>
          <Col md={12}>
            <Checkbox checked={otherLicense} onChange={this.handleOtherLicenseToggle}>Other current license or certificate</Checkbox>
            <Checkbox checked={otherWorkHours} onChange={this.handleOtherWorkHoursToggle}>Total Work Experience with direct patient care > 1000 hours</Checkbox>
            <Checkbox checked={volunteerHours} onChange={this.handleVolunteerHoursToggle}>Total Volunteer experience with direct patient care > 200 hours</Checkbox>
            <Checkbox checked={!otherLicense && !otherWorkHours && !volunteerHours}>None</Checkbox>
          </Col>
        </FormGroup>
        {otherLicense &&
        <FormGroup controlId="other-license-name">
          <Col md={12}>
            <p>Please list the license/certificate. <em className="text-danger">Please note Lifeguard and CPR certificates will not be accepted and will result in disqualification.</em></p>
            <FormControl
              componentClass="input"
              type="text"
              value={professionalInfo.otherLicenseOrCert.name}
              placeholder="Enter License or Certificate Name"
              onChange={this.handleOtherLicenseNameChange}
            />
            <FormControl.Feedback />
          </Col>
        </FormGroup>
        }
      </div>)
  }
}

export default OtherWorkExperience;